var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMomSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7113_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71153 7.62716C9.75298 7.62716 11.4054 5.92212 11.4054 3.81565C11.4054 1.70918 9.75298 0 7.71153 0C5.67009 0 4.01367 1.70504 4.01367 3.81151C4.01367 5.91798 5.66608 7.62302 7.70752 7.62302",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1221 14.3608C13.1221 15.8465 11.955 17.0549 10.5111 17.0549C9.06728 17.0549 7.90017 15.8506 7.90017 14.3608C7.90017 12.8709 9.06728 11.6667 10.5111 11.6667C11.955 11.6667 13.1221 12.8709 13.1221 14.3608ZM15.7651 14.6381C15.7651 12.6268 14.9189 7.7641 7.52717 8.389C6.0753 8.51316 1.72771 8.1407 0.500435 13.5124C-1.61721 22.7908 9.5245 23.3867 9.03921 20.3864C9.03921 20.3864 8.25311 19.1986 6.43626 19.0124C4.61942 18.8262 4.6515 14.307 5.40552 14.0132C7.1622 13.3262 6.92156 17.9488 9.76514 18.0771C9.76514 18.0771 9.21969 20.076 10.4911 20.5767C11.7625 21.0775 15.7611 20.4526 15.7611 14.6381",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7113_455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5294,
    height: 22,
    fill: "white",
    transform: "translate(0.235352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomSmall);
export default __webpack_public_path__ + "static/media/momSmall.19f9cd9b.svg";
export { ForwardRef as ReactComponent };